/** Svenska. */
export default {
  header: {
    features: 'Funktioner',
    pricing: 'Priser',
    contact: 'Kontakt',
    getStarted: 'Kom igång',
    login: 'Logga in',
  },

  footer: {
    description:
      'En plattform för medlemmar, uthyrning av lokaler, evenemang och bokföring, gjord för föreningar.',
    product: 'Produkt',
    help: 'Hjälp',
    legal: 'Juridik',
    features: 'Funktioner',
    pricing: 'Priser',
    getStarted: 'Kom igång',
    contactUs: 'Kontakta oss',
    privacy: 'Integritet',
    terms: 'Villkor',
    copyright: 'Alla rättigheter förbehållna.',
  },

  home: {
    unknownTenant:
      'Ingen aktiv förening hittades på {host}. Om föreningen precis har skapats kan det ta några minuter innan sidan är klar - prova att ladda om sidan om en stund. Om du är osäker på adressen, eller om problemet kvarstår, är du välkommen att',
    unknownTenantHere: 'den här adressen',
    unknownTenantContact: 'kontakta oss',
    heroTitlePre: 'Digitalisera din förening med',
    heroSubtitle:
      'En plattform för medlemmar, uthyrning av lokaler, evenemang och bokföring, gjord för föreningar.',
    ctaFree: 'Kom igång gratis',
    learnMore: 'Läs mer',
    featuresTitle: 'Det du behöver för att driva föreningen',
    featuresSubtitle: 'Verktygen samlade i en plattform',
    features: [
      { icon: '👥', title: 'Medlemsregister', desc: 'Medlemmar, medlemskap och hushåll, med faktura när medlemskapet förnyas.' },
      { icon: '🏠', title: 'Uthyrning av lokaler', desc: 'Bokning med priser, avtal, deposition och faktura.' },
      { icon: '📅', title: 'Evenemang', desc: 'Biljettförsäljning med kapacitet, och QR-kod vid dörren.' },
      { icon: '💳', title: 'Faktura och betalning', desc: 'Fakturor och kreditnotor, och betalning med kort och Vipps via Nets.' },
      { icon: '📧', title: 'E-post och SMS', desc: 'Bekräftelser, påminnelser, fakturor och biljetter skickas automatiskt.' },
      { icon: '🌐', title: 'Egen webbplats', desc: 'Föreningens egen sida med sidor, nyheter och eget utseende.' },
    ],
    stepsTitle: 'Så kommer du igång',
    steps: [
      { num: 1, title: 'Skicka en förfrågan', desc: 'Berätta om föreningen, så ställer vi in er sida.' },
      { num: 2, title: 'Ställ in', desc: 'Lägg in lokaler, medlemskapstyper och priser.' },
      { num: 3, title: 'Börja använda', desc: 'Ta emot bokningar, sälj biljetter och skicka fakturor.' },
    ],
    ctaTitle: 'Redo att förenkla föreningslivet?',
    ctaText: 'Börja gratis idag. Ingen bindningstid.',
    ctaButton: 'Kom igång gratis',
    heroImageAlt: 'Översikten i administrationen för en demoförening',
  },

  features: {
    heroTitle: 'Kraftfulla funktioner för din förening',
    heroSubtitle: 'Medlemmar, uthyrning, evenemang, fakturering och bokföring i en plattform.',
    list: [
      {
        icon: '👥',
        title: 'Medlemshantering',
        description: 'Medlemmar, medlemskap och hushåll samlade på ett ställe.',
        details: [
          'Medlemskapstyper och hushåll med barn',
          'Förnyelse med faktura',
          'Ideellt arbete och timmar',
        ],
      },
      {
        icon: '🏠',
        title: 'Uthyrning av lokaler',
        description: 'Ta emot och följ upp bokningar.',
        details: ['Priser, tillägg och helgdagar', 'Avtal som signeras online', 'Deposition och faktura'],
      },
      {
        icon: '📅',
        title: 'Evenemang',
        description: 'Sälj biljetter och släpp in rätt personer.',
        details: [
          'Biljettförsäljning med kapacitet',
          'Biljettyper i ordning, till exempel early bird och dörrförsäljning',
          'QR-kod vid dörren',
        ],
      },
      {
        icon: '💳',
        title: 'Faktura och betalning',
        description: 'Fakturor och kreditnotor, och kortbetalning.',
        details: ['Faktura med påminnelse', 'Kort och Vipps via Nets', 'Bokföring och kontoplan'],
      },
      {
        icon: '📧',
        title: 'Kommunikation',
        description: 'Meddelanden skickas automatiskt vid rätt tidpunkt.',
        details: ['E-post och SMS', 'Mallar på flera språk', 'Aviseringar vid rätt tidpunkt'],
      },
      {
        icon: '🌐',
        title: 'Egen webbplats',
        description: 'Föreningens egen sida med sidor och nyheter.',
        details: ['Sidor och nyheter', 'Tre utseenden och egna färger', 'Egen domän (ställs in av oss)'],
      },
      {
        icon: '🔐',
        title: 'Säkerhet och integritet',
        description: 'Varje förening hålls skild från de andra.',
        details: [
          'Tvåfaktorsinloggning',
          'Data lagras i Norge',
          'Åtkomst, export och radering av personuppgifter',
        ],
      },
    ],
    ctaTitle: 'Redo att komma igång?',
    ctaText: 'Börja gratis idag och upplev hur enkelt det kan vara att driva en förening.',
    ctaButton: 'Kom igång gratis',
    screensTitle: 'Så ser det ut',
    screensSubtitle:
      'Skärmbilder från en demoförening med påhittade data. Administrationen är på norska.',
    screens: [
      { title: 'Översikt', text: 'Det som behöver följas upp, och vad som händer framöver, på en sida.' },
      { title: 'Bokningar', text: 'Förfrågningar, bekräftelser och status för alla bokningar.' },
      { title: 'Kalender', text: 'Besökare ser när lokalerna är lediga och vad som händer i huset.' },
      { title: 'Biljetter', text: 'Försäljning per biljettyp, deltagare och incheckning.' },
      { title: 'Välj plats', text: 'Köparen väljer sina platser på kartan över lokalen.' },
      { title: 'Salsplan', text: 'Dra bord, stolar, scen och bar in på kartan, med planritningen som bakgrund.' },
      { title: 'Medlemskap', text: 'Medlemmar, medlemskapstyper och hushåll.' },
      { title: 'Fakturor', text: 'Fakturor och kreditnotor med status, förfallodag och utestående belopp.' },
      { title: 'I telefonen', text: 'Föreningens webbplats fungerar i telefonen.' },
    ],
  },

  pricing: {
    heroTitle: 'Enkel och transparent prissättning',
    heroSubtitle: 'Välj den plan som passar din förening.',
    loading: 'Laddar priser...',
    loadError: 'Kunde inte hämta uppdaterade priser. Visar sparade priser.',
    popular: 'Mest populär',
    perMonth: 'kr/mån',
    unlimited: 'Obegränsat',
    unlimitedMembers: 'Obegränsat antal medlemmar',
    upToMembers: 'Upp till {count} medlemmar',
    prioritySupport: 'Prioriterad support: vi påbörjar inom 30 minuter, vardagar 09–15',
    planDescFree: 'För små föreningar',
    planDescStandard: 'För aktiva föreningar',
    planDescAdvanced: 'För stora organisationer',
    ctaFree: 'Kom igång gratis',
    ctaTrial: 'Skicka en förfrågan',
    faqTitle: 'Vanliga frågor',
    faq: [
      { q: 'Kan jag byta plan när som helst?', a: 'Ja, hör av dig, så byter vi plan.' },
      { q: 'Vad händer om vi överskrider medlemsgränsen?', a: 'Vi hör av oss och kommer överens om en uppgradering. Inget stängs av utan att vi har pratat med er.' },
      { q: 'Finns det bindningstid?', a: 'Nej, alla planer kan sägas upp när som helst.' },
      { q: 'Erbjuder ni rabatter för ideella organisationer?', a: 'Ja, kontakta oss för särskilda priser för ideella organisationer.' },
      { q: 'Vad kostar kortbetalning?', a: 'Kort och Vipps går via Nets. Föreningen har ett eget avtal med Nets och betalar avgiften direkt till dem.' },
    ],
    emailSms: 'E-post och SMS',
    bookingsPerMonth: '{count} bokningar i månaden',
    unlimitedBookings: 'Obegränsat antal bokningar',
    ticketsPerMonth: '{count} biljetter i månaden',
    unlimitedTickets: 'Obegränsat antal biljetter',
    locations: 'Upp till {count} lokaler',
    unlimitedLocations: 'Obegränsat antal lokaler',
    storage: '{size} lagring',
    customBranding: 'Eget utseende och egna färger',
    exportCsv: 'Export till CSV',
    introNotice:
      'Under en inledande period är alla planer gratis. Vi meddelar minst 30 dagar innan faktureringen börjar.',
  },

  contact: {
    heroTitle: 'Kontakta oss',
    heroSubtitle: 'Vi finns här för att hjälpa. Skriv till oss, så svarar vi så snart vi kan.',
    formTitle: 'Skriv till oss',
    formIntro:
      'Har du frågor om CommunityNord, priser eller hur vi kan hjälpa din förening? Fyll i formuläret, eller skicka ett e-postmeddelande.',
    email: 'E-post',
    name: 'Namn',
    organization: 'Förening/Organisation',
    subject: 'Ämne',
    chooseSubject: 'Välj ämne',
    subjectGeneral: 'Allmän fråga',
    subjectPricing: 'Priser och abonnemang',
    subjectSupport: 'Teknisk support',
    subjectDemo: 'Boka en demo',
    subjectPartnership: 'Samarbete',
    message: 'Meddelande',
    send: 'Skicka meddelande',
    success: 'Tack! Vi har tagit emot ditt meddelande och hör av oss så snart vi kan.',
    error: 'Något gick fel. Försök igen, eller skicka ett e-postmeddelande.',
    tooMany:
      'Du har skickat många meddelanden. Försök igen senare, eller skicka ett e-postmeddelande.',
    sending: 'Skickar...',
    supportNote:
      'Standard och Avancerad har prioriterad support: vi påbörjar ärendet inom 30 minuter, vardagar 09–15.',
  },

  login: {
    title: 'Logga in',
    subtitle:
      'Varje förening har sin egen inloggning. Skriv föreningens adress, så tar vi dig dit.',
    label: 'Föreningens adress',
    placeholder: 'foreningen',
    button: 'Gå till inloggningen',
    hint:
      'Har föreningen en egen domän använder du den i stället. Hittar du inte adressen, fråga styrelsen eller kontakta oss.',
    invalid: 'Använd bara små bokstäver, siffror och bindestreck.',
  },

  signup: {
    heroTitle: 'Kom igång med CommunityNord',
    heroSubtitle:
      'Fyll i formuläret för att skapa en ny förening. Vi skickar ett e-postmeddelande när ditt konto är klart.',
    formTitle: 'Skapa ny förening',
    success:
      'Tack för din förfrågan! Vi har tagit emot den och kontaktar dig så snart ditt konto är klart.',
    error: 'Något gick fel vid inskickningen. Försök igen eller kontakta oss.',
    orgName: 'Organisationsnamn',
    orgNamePlaceholder: 'Föreningens namn',
    contactPerson: 'Kontaktperson',
    contactPersonPlaceholder: 'Ditt fullständiga namn',
    email: 'E-post',
    phone: 'Telefon',
    plan: 'Önskat abonnemang',
    messageOptional: 'Meddelande (valfritt)',
    messagePlaceholder: 'Berätta lite om din förening...',
    sending: 'Skickar...',
    submit: 'Skicka förfrågan',
    free: 'Gratis',
    perMonth: 'kr/mån',
    upTo50: 'Upp till 50 medlemmar',
    upTo500: 'Upp till 500 medlemmar',
    unlimitedMembers: 'Obegränsat antal medlemmar',
    nextTitle: 'Vad händer sedan?',
    nextSteps: [
      { title: 'Förfrågan skickad', desc: 'Vi tar emot din förfrågan och skickar en bekräftelse till din e-post.' },
      { title: 'Handläggning', desc: 'Vårt team behandlar din förfrågan, vanligtvis inom 1-2 arbetsdagar.' },
      { title: 'Välkommen', desc: 'Du får en inbjudningslänk via e-post för att skapa ditt konto.' },
    ],
    questionsTitle: 'Har du frågor?',
    questionsContact: 'Kontakta oss på',
  },

  onboarding: {
    homeTitle: 'CommunityNord Onboarding',
    homeSubtitle:
      'För att skapa en ny organisation behöver du en inbjudningslänk. Kontakta en administratör för att få en.',
    homeGotLink: 'Har du fått en länk?',
    homeGotLinkText: 'Klicka på länken du fått via e-post för att börja konfigurera din organisation.',
    homeBack: '← Tillbaka till communitynord.com',
    validating: 'Validerar inbjudan...',
    invalidTitle: 'Ogiltig inbjudan',
    invalidContact: 'Kontakta administratören för att få en ny inbjudningslänk.',
    connectError: 'Kunde inte nå servern. Försök igen senare.',
    deviceBound:
      'Den här länken har redan öppnats på en annan enhet och är kopplad till den. Öppna länken på den första enheten för att fortsätta, eller skriv till support@communitynord.com så skickar vi en ny länk.',
    genericError: 'Något gick fel. Försök igen.',
    steps: ['Välkommen', 'Organisation', 'Kontakt', 'Konto', 'Bekräfta'],
    step1Title: 'Välkommen till CommunityNord',
    step1Subtitle:
      'Du har blivit inbjuden att skapa en ny organisation. Vi guidar dig genom uppsättningen steg för steg.',
    step1Suggested: 'Föreslaget namn:',
    step1SentTo: 'Inbjudan skickad till:',
    step1Expires: 'Inbjudan går ut:',
    step1Needs: 'Det här behöver du:',
    step1NeedsList: [
      'Organisationens namn',
      'Kontaktuppgifter',
      'Eventuellt organisationsnummer',
      'Önskat användarnamn och lösenord',
    ],
    step1Start: 'Kom igång →',
    back: '← Tillbaka',
    next: 'Nästa →',
    step2Title: 'Om organisationen',
    step2Subtitle: 'Berätta om organisationen som ska använda plattformen.',
    orgName: 'Organisationsnamn',
    orgNamePlaceholder: 'T.ex. Solna Ungdomsgård',
    orgNameRequired: 'Organisationsnamn krävs',
    slug: 'URL-prefix (slug)',
    slugRequired: 'URL-prefix krävs',
    slugFormat: 'Endast små bokstäver, siffror och bindestreck',
    slugMin: 'Minst 2 tecken',
    shortName: 'Kortnamn',
    shortNameRequired: 'Kortnamn krävs',
    shortNameMax: 'Max 10 tecken',
    shortNameFormat: 'Endast bokstäver och siffror',
    shortNameHint: 'Används som prefix i fakturanummer m.m.',
    customDomain: 'Egen domän',
    customDomainPlaceholder: 't.ex. exempel.se',
    customDomainHint: 'Valfritt. Ger åtkomst via egen domän utöver subdomänen.',
    customDomainNoProtocol: 'Ange endast domänen, utan http:// eller https://',
    customDomainNoPath: 'Ange endast domänen, utan sökväg',
    customDomainInvalid: 'Ogiltigt domänformat',
    country: 'Land',
    countryHint: 'Landet organisationen hör hemma i',
    countryNames: { NO: 'Norge', SE: 'Sverige', DK: 'Danmark' },
    orgNumber: 'Organisationsnummer',
    orgNumberHint: 'Valfritt. Organisationsnummer.',
    appearance: 'Utseende',
    layout: 'Webbplatsens utseende',
    layoutHint: 'Kan ändras när som helst under Admin → Varumärke.',
    layouts: [
      { key: 'classic', name: 'Klassisk', description: 'Traditionell layout med centrerat innehåll och logotyp till vänster. Passar de flesta.' },
      { key: 'modern', name: 'Modern', description: 'Fullbreddsstartsida och kompakt meny. Fräsch och luftig stil.' },
      { key: 'compact', name: 'Kompakt', description: 'Minimalt med luft och tät information. Bra för innehållsrika sidor.' },
      { key: 'custom', name: 'Skräddarsydd', description: 'Egen design framtagen tillsammans med oss. Vi hör av oss.' },
    ],
    tagline: 'Slogan / motto',
    taglinePlaceholder: 'T.ex. ”Tillsammans skapar vi aktivitet”',
    taglineHint: 'Valfritt. Visas i sidfoten på webbplatsen.',
    logo: 'Logotyp',
    logoUpload: 'Ladda upp logotyp',
    logoChange: 'Byt bild',
    logoRemove: 'Ta bort',
    logoHint: 'Valfritt. PNG/JPG/SVG, max 2 MB. Kan även läggas till senare.',
    logoTooBig: 'Bilden är för stor (max 2 MB)',
    logoNotImage: 'Filen måste vara en bild',
    logoUseUrl: 'Använd URL istället',
    logoUrlPlaceholder: 'https://...',
    logoUrlHint: 'Absolut URL till logotypen (https://...).',
    subscriptionPlan: 'Abonnemangsplan',
    subscriptionPlanHint: 'Planen sätts som startplan och kan ändras i portalen senare.',
    step3Title: 'Kontaktuppgifter',
    step3Subtitle: 'Vem är huvudkontakt för organisationen? Den personen blir kontots ägare.',
    contactPerson: 'Kontaktperson',
    contactPersonRequired: 'Kontaktperson krävs',
    email: 'E-postadress',
    emailRequired: 'E-post krävs',
    emailInvalid: 'Ogiltig e-postadress',
    phone: 'Telefonnummer',
    postalAddress: 'Postadress',
    optional: '(valfritt)',
    streetAddress: 'Gatuadress',
    city: 'Ort',
    postalCode: 'Postnr',
    sameAsPostal: 'Besöksadressen är samma som postadressen',
    visitingAddress: 'Besöksadress',
    step4Title: 'Skapa användarkonto',
    step4Subtitle:
      'Den här användaren blir organisationens ägare med full åtkomst. Du kan lägga till fler användare senare.',
    username: 'Användarnamn',
    usernameRequired: 'Användarnamn krävs',
    usernameMin: 'Minst 3 tecken',
    usernameMax: 'Max 256 tecken',
    usernameEmailInvalid: 'Ogiltigt e-postformat',
    usernameFormat:
      'Använd användarnamnsformat (a-z, 0-9, punkt, understreck, bindestreck) eller en giltig e-postadress',
    usernamePlaceholder: 'anna.svensson eller namn@domän.se',
    usernameHint: 'Används vid inloggning. Kan vara användarnamn eller e-postadress.',
    loginEmail: 'E-post (för inloggning)',
    loginEmailHint: 'Hämtad från kontaktuppgifterna i föregående steg.',
    password: 'Lösenord',
    passwordRequired: 'Lösenord krävs',
    passwordMin: 'Minst 8 tecken',
    passwordShow: 'Visa',
    passwordHide: 'Dölj',
    passwordHint: 'Tips: Använd en blandning av stora/små bokstäver, siffror och specialtecken.',
    passwordConfirm: 'Bekräfta lösenord',
    passwordConfirmPlaceholder: 'Upprepa lösenordet',
    passwordMismatch: 'Lösenorden matchar inte',
    step5Title: 'Bekräfta och skapa',
    step5Subtitle:
      'Gå igenom informationen innan du skapar organisationen. Du kan gå tillbaka för att göra ändringar.',
    reviewOrg: 'Organisation',
    reviewName: 'Namn',
    reviewUrl: 'URL',
    reviewCustomDomain: 'Egen domän',
    reviewCountry: 'Land',
    reviewShortName: 'Kortnamn',
    reviewOrgNumber: 'Org.nr',
    reviewPlan: 'Abonnemang',
    reviewLayout: 'Utseende',
    reviewTagline: 'Slogan',
    reviewLogo: 'Logotyp',
    reviewContact: 'Kontakt',
    reviewContactPerson: 'Kontaktperson',
    reviewEmail: 'E-post',
    reviewPhone: 'Telefon',
    reviewPostal: 'Postadress',
    reviewVisiting: 'Besöksadress',
    reviewAddress: 'Adress',
    reviewPlace: 'Ort',
    reviewAccount: 'Användarkonto',
    reviewUsername: 'Användarnamn',
    reviewPassword: 'Lösenord',
    reviewRole: 'Roll',
    reviewOwner: 'Ägare (Owner)',
    creating: 'Skapar...',
    create: 'Skapa organisation ✓',
    successTitle: '{name} har skapats!',
    successAwaiting:
      'Vi förbereder nu er webbplats — detta är ett manuellt steg där vi kontrollerar att allt är rätt uppsatt. Ni får ett e-postmeddelande till {email} så snart sidan är klar att använda.',
    successAwaitingNoEmail:
      'Vi förbereder nu er webbplats — detta är ett manuellt steg där vi kontrollerar att allt är rätt uppsatt. Ni får ett e-postmeddelande så snart sidan är klar att använda.',
    successWhatNow: 'Vad händer nu?',
    successStep1: 'Vi kontrollerar uppsättningen och gör sidan klar. Det tar vanligtvis kort tid.',
    successStep2: 'Ni får ett e-postmeddelande när sidan är klar, med en inloggningslänk.',
    successStep3: 'Logga in med användarnamnet {username} och lösenordet ni valde.',
    successDetails: 'Dina uppgifter',
    successOrg: 'Organisation',
    successUrl: 'Webbadress',
    successUsername: 'Användarnamn',
    successDnsTitle: 'Egen domän: {domain}',
    successDnsIntro:
      'För att {domain} ska peka till er webbplats måste DNS-inställningarna hos er domänleverantör uppdateras. Välj ett av alternativen:',
    successDnsCnameTitle: 'Alternativ 1 — CNAME (enklast)',
    successDnsCnameText: 'Skapa en CNAME-post som pekar till er subdomän:',
    successDnsATitle: 'Alternativ 2 — A-post',
    successDnsAText: 'Peka domänen direkt till vår server-IP:',
    successDnsNote:
      'DNS-ändringar kan ta upp till några timmar att slå igenom. Obs: en CNAME kan inte användas på en rotdomän (exempel.se) hos alla leverantörer — använd då en A-post, eller CNAME på www. Vi verifierar domänen som en del av förberedelsen.',
    successDnsType: 'Typ',
    successDnsName: 'Namn/värd',
    successDnsValue: 'Värde/mål',
  },
}
